export interface Product {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: string;
}

export const products: Product[] = [
  {
    id: 'prod_S5tMtTLXvY8Fq6',
    priceId: 'price_1RBhZyL62EDjde5JYha47v1Y',
    name: 'ImmoIQ',
    description: 'Digitales Informationsprodukt zur Verbesserung des Cashflows bei vermieteten Immobilien. ImmoIQ zeigt privaten Eigentümern, wie sie Mieteinnahmen erhöhen, den Objektwert steigern, Steuern sparen und Verwaltungskosten senken können – einfach, verständlich und sofort umsetzbar.',
    mode: 'payment',
    price: '5.000,00 €'
  }
];